import { VisibilityState } from "@tanstack/react-table";

import { DatatableColumn } from "../datatable-types";

export const resolveColumnVisibilityFromUrl = (
  urlParams: URLSearchParams,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): VisibilityState | undefined => {
  const columnVisibility = urlParams.get("columnVisibility");

  if (!columnVisibility) {
    return undefined;
  }

  try {
    const parsedVisibility = JSON.parse(decodeURIComponent(columnVisibility)) as VisibilityState;

    // Validate column IDs against the provided columns configuration using flatMap
    const filteredVisibility: VisibilityState = Object.fromEntries(
      Object.entries(parsedVisibility).flatMap(([columnId, isVisible]) => {
        const column = columns.find((col) => col.columnId === columnId);

        if (column && column.getColumnDef().enableHiding) {
          return [[columnId, isVisible]];
        }

        return [];
      }),
    );

    return filteredVisibility;
  } catch (error) {
    console.error("Failed to parse columnVisibility from URL:", error);
    return undefined;
  }
};

export const encodeColumnVisibilityToUrl = (
  urlParams: URLSearchParams,
  columnVisibility: VisibilityState | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (columnVisibility) {
    // Validate column IDs against the provided columns configuration
    const validColumnVisibility: VisibilityState = Object.fromEntries(
      Object.entries(columnVisibility).flatMap(([columnId, isVisible]) => {
        const column = columns.find((col) => col.columnId === columnId);

        // Include the column only if it exists and has `enableHiding: true`
        if (column && column.getColumnDef().enableHiding) {
          return [[columnId, isVisible]];
        }

        return [];
      }),
    );

    updatedParams.set("columnVisibility", JSON.stringify(validColumnVisibility)); // Convert the filtered object to a JSON string
  } else {
    updatedParams.delete("columnVisibility"); // Remove the parameter if the value is undefined
  }

  return updatedParams;
};
